<template>
  <div class="container">
    <span>暂无数据.</span>
  </div>
</template>

<script>
export default {};
</script>

<style lang="less" scoped>
.container {
  width: 100%;
  height: 200px;
  line-height: 200px;
  text-align: right;
  padding: 40px;
  span {
    font-family: 宋体;
    font-weight: bold;
    color: #9b9b9b;
    font-size: 18px;
  }
}
</style>
